import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-6 md:mb-0">
            <h2 className="text-2xl font-bold">Quick Chef</h2>
            <p className="mt-2 text-gray-400">{t("footer.tagline")}</p>
          </div>
          <div className="flex space-x-6">
            <a
              href="https://x.com/quickchefai"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white"
            >
              <img
                src="/icons/twitter.svg"
                alt="Twitter"
                className="w-6 h-6 filter invert opacity-75 hover:opacity-100 transition-opacity"
              />
            </a>
            <a
              href="https://facebook.com/quickchef"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white"
            >
              <img
                src="/icons/facebook.svg"
                alt="Facebook"
                className="w-6 h-6 filter invert opacity-75 hover:opacity-100 transition-opacity"
              />
            </a>
            <a
              href="https://www.instagram.com/quickchefai"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white"
            >
              <img
                src="/icons/instagram.svg"
                alt="Instagram"
                className="w-6 h-6 filter invert opacity-75 hover:opacity-100 transition-opacity"
              />
            </a>
            <a
              href="https://www.tiktok.com/@zik_unlimited?_t=8rqzwemfEoA&_r=1"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white"
            >
              <img
                src="/icons/tiktok.svg"
                alt="TikTok"
                className="w-6 h-6 filter invert opacity-75 hover:opacity-100 transition-opacity"
              />
            </a>
            <a
              href="https://www.reddit.com/r/quickchef/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 dark:text-gray-500 hover:text-white dark:hover:text-gray-300"
            >
              <img
                src="/icons/reddit.svg"
                alt="Reddit"
                className="w-6 h-6 filter invert opacity-75 hover:opacity-100 transition-opacity"
              />
            </a>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-800 dark:border-gray-700 flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <Link
              to="/terms"
              className="text-gray-400 dark:text-gray-500 hover:text-white dark:hover:text-gray-300 mr-4"
            >
              {t("footer.terms")}
            </Link>
            <Link
              to="/privacy"
              className="text-gray-400 dark:text-gray-500 hover:text-white dark:hover:text-gray-300"
            >
              {t("footer.privacy")}
            </Link>
          </div>
          <p className="text-gray-400 dark:text-gray-500">
            {t("footer.copyright")}
          </p>
        </div>
      </div>
    </footer>
  );
}
